const GEO_LOCATION_CACHE_KEY = "homeUserCityLocation";
const GEO_LOCATION_CACHE_DURATION = 30 * 60 * 1000;
const COUNTRY_TRANSLATION_KEYS = {
  china: "china",
  "people's republic of china": "china",
  korea: "southKorea",
  "south korea": "southKorea",
  "republic of korea": "southKorea",
  japan: "japan",
  singapore: "singapore",
  thailand: "thailand",
  vietnam: "vietnam",
  malaysia: "malaysia",
  taiwan: "taiwan",
  "hong kong": "hongKong",
  macau: "macau",
  philippines: "philippines",
  indonesia: "indonesia",
  "united states": "unitedStates",
  usa: "unitedStates",
  america: "unitedStates",
  canada: "canada",
  australia: "australia",
  "united kingdom": "unitedKingdom",
  uk: "unitedKingdom",
  france: "france",
  germany: "germany",
  italy: "italy",
  russia: "russia",
  india: "india",
};

function normalizeLocale(locale) {
  const localeMap = {
    zh: "zh-CN",
    en: "en",
    ja: "ja",
    kr: "ko",
    ar: "ar",
    es: "es",
    de: "de",
    pt: "pt",
    it: "it"
  };

  return localeMap[locale] || "en";
}

function buildReverseGeocodeUrl({ latitude, longitude, locale = "en" }) {
  const params = [
    `latitude=${encodeURIComponent(latitude)}`,
    `longitude=${encodeURIComponent(longitude)}`,
    `localityLanguage=${encodeURIComponent(normalizeLocale(locale))}`,
  ];

  return `https://api.bigdatacloud.net/data/reverse-geocode-client?${params.join("&")}`;
}

function getPrimaryCityName(payload = {}) {
  const administrativeList =
    payload.localityInfo &&
    Array.isArray(payload.localityInfo.administrative)
      ? payload.localityInfo.administrative
      : [];

  const candidates = [
    payload.city,
    payload.locality,
    payload.principalSubdivision,
    administrativeList.length ? administrativeList[0].name : "",
    payload.countryName,
  ];

  return candidates.find((item) => typeof item === "string" && item.trim()) || "";
}

function extractCountryName(payload = {}) {
  return typeof payload.countryName === "string" && payload.countryName.trim()
    ? payload.countryName.trim()
    : "";
}

function getCountryTranslationKey(countryName) {
  const normalizedCountryName = String(countryName || "").trim().toLowerCase();
  return COUNTRY_TRANSLATION_KEYS[normalizedCountryName] || "";
}

function extractCountryCity(payload = {}) {
  const cityName = getPrimaryCityName(payload);
  const countryName = extractCountryName(payload);

  if (countryName && cityName && countryName !== cityName) {
    return `${countryName} ${cityName}`;
  }

  return cityName || countryName;
}

module.exports = {
  GEO_LOCATION_CACHE_KEY,
  GEO_LOCATION_CACHE_DURATION,
  buildReverseGeocodeUrl,
  extractCountryName,
  extractCountryCity,
  getCountryTranslationKey,
};
